document.addEventListener("DOMContentLoaded", () => {

  const headers = document.querySelectorAll("[data-bh-header]");

  if (!headers.length) return;


  headers.forEach((header) => {

    /* =====================================================
       ELEMENTS
    ===================================================== */

    const burger =
      header.querySelector("[data-bh-burger]");

    const mobileNav =
      header.querySelector("[data-bh-mobile-nav]");

    const closeButton =
      header.querySelector("[data-bh-close]");

    const overlay =
      header.querySelector("[data-bh-overlay]");

    const searchToggle =
      header.querySelector("[data-bh-search-toggle]");

    const searchPanel =
      header.querySelector("[data-bh-search-panel]");

    const searchInput =
      header.querySelector("[data-bh-search-input]");

    const dropdownItems =
      header.querySelectorAll(
        ".bh-nav > ul > li.bh-has-dropdown"
      );

    const mobileSubToggles =
      header.querySelectorAll(
        ".bh-mobile-nav__toggle"
      );


    /* =====================================================
       DESKTOP DROPDOWN
       HOVER TO OPEN
    ===================================================== */

    const closeAllDropdowns = (except = null) => {

      dropdownItems.forEach((item) => {

        if (item === except) return;

        const dropdown =
          item.querySelector(
            "[data-bh-dropdown]"
          );

        const trigger =
          item.querySelector(
            "[data-bh-dropdown-trigger]"
          );

        if (dropdown) {
          dropdown.classList.remove(
            "bh-open"
          );
        }

        if (trigger) {
          trigger.setAttribute(
            "aria-expanded",
            "false"
          );
        }

      });

    };


    dropdownItems.forEach((item) => {

      const trigger =
        item.querySelector(
          "[data-bh-dropdown-trigger]"
        );

      const dropdown =
        item.querySelector(
          "[data-bh-dropdown]"
        );

      if (!trigger || !dropdown) return;


      let closeTimer = null;


      const openDropdown = () => {

        if (window.innerWidth <= 860) {
          return;
        }

        clearTimeout(closeTimer);

        closeAllDropdowns(item);

        dropdown.classList.add(
          "bh-open"
        );

        trigger.setAttribute(
          "aria-expanded",
          "true"
        );

      };


      const closeDropdown = () => {

        if (window.innerWidth <= 860) {
          return;
        }

        clearTimeout(closeTimer);

        closeTimer = setTimeout(() => {

          dropdown.classList.remove(
            "bh-open"
          );

          trigger.setAttribute(
            "aria-expanded",
            "false"
          );

        }, 120);

      };


      /* -----------------------------------------------
         HOVER
      ------------------------------------------------ */

      item.addEventListener(
        "mouseenter",
        openDropdown
      );


      item.addEventListener(
        "mouseleave",
        closeDropdown
      );


      /* -----------------------------------------------
         KEYBOARD ACCESSIBILITY
      ------------------------------------------------ */

      trigger.addEventListener(
        "focus",
        openDropdown
      );


      item.addEventListener(
        "focusout",
        (event) => {

          if (
            !item.contains(
              event.relatedTarget
            )
          ) {

            closeDropdown();

          }

        }
      );


      /* -----------------------------------------------
         CLICK
         Desktop click does NOT toggle dropdown.
         Normal link navigation is preserved.
      ------------------------------------------------ */

      trigger.addEventListener(
        "click",
        (event) => {

          if (window.innerWidth > 860) {

            /*
             * If the link has a real URL,
             * allow normal navigation.
             *
             * Dropdown itself is controlled
             * by hover only.
             */

            const href =
              trigger.getAttribute("href");

            if (
              !href ||
              href === "#" ||
              href === "javascript:void(0)"
            ) {

              event.preventDefault();

            }

            openDropdown();

          }

        }
      );

    });


    /* =====================================================
       CLOSE DROPDOWN WHEN CLICKING OUTSIDE
    ===================================================== */

    document.addEventListener(
      "click",
      (event) => {

        if (!header.contains(event.target)) {

          closeAllDropdowns();

        }

      }
    );


    /* =====================================================
       MOBILE MENU
    ===================================================== */

    const openMobileMenu = () => {

      if (!mobileNav) return;

      mobileNav.hidden = false;

      if (overlay) {
        overlay.hidden = false;
      }

      requestAnimationFrame(() => {

        mobileNav.classList.add(
          "bh-open"
        );

        if (overlay) {
          overlay.classList.add(
            "bh-open"
          );
        }

      });

      if (burger) {

        burger.setAttribute(
          "aria-expanded",
          "true"
        );

      }

      document.documentElement.classList.add(
        "bh-menu-open"
      );

    };


    const closeMobileMenu = () => {

      if (!mobileNav) return;

      mobileNav.classList.remove(
        "bh-open"
      );

      if (overlay) {

        overlay.classList.remove(
          "bh-open"
        );

      }

      if (burger) {

        burger.setAttribute(
          "aria-expanded",
          "false"
        );

      }

      document.documentElement.classList.remove(
        "bh-menu-open"
      );


      setTimeout(() => {

        mobileNav.hidden = true;

        if (overlay) {
          overlay.hidden = true;
        }

      }, 300);

    };


    if (burger) {

      burger.addEventListener(
        "click",
        () => {

          const isOpen =
            burger.getAttribute(
              "aria-expanded"
            ) === "true";

          if (isOpen) {

            closeMobileMenu();

          } else {

            closeAllDropdowns();

            openMobileMenu();

          }

        }
      );

    }


    if (closeButton) {

      closeButton.addEventListener(
        "click",
        closeMobileMenu
      );

    }


    if (overlay) {

      overlay.addEventListener(
        "click",
        closeMobileMenu
      );

    }


    /* =====================================================
       MOBILE SUBMENUS
       CLICK / TAP TO OPEN
    ===================================================== */

    mobileSubToggles.forEach((toggle) => {

      toggle.addEventListener(
        "click",
        () => {

          const parent =
            toggle.closest(
              ".bh-mobile-has-sub"
            );

          if (!parent) return;


          const isOpen =
            parent.classList.contains(
              "bh-sub-open"
            );


          /* Close other mobile submenus */

          header
            .querySelectorAll(
              ".bh-mobile-has-sub.bh-sub-open"
            )
            .forEach((item) => {

              if (item !== parent) {

                item.classList.remove(
                  "bh-sub-open"
                );

                const button =
                  item.querySelector(
                    ".bh-mobile-nav__toggle"
                  );

                if (button) {

                  button.setAttribute(
                    "aria-expanded",
                    "false"
                  );

                }

              }

            });


          parent.classList.toggle(
            "bh-sub-open",
            !isOpen
          );


          toggle.setAttribute(
            "aria-expanded",
            String(!isOpen)
          );

        }
      );

    });


    /* =====================================================
       CLOSE MOBILE ON MOBILE LINK CLICK
    ===================================================== */

    if (mobileNav) {

      mobileNav
        .querySelectorAll(
          "a:not(.bh-mobile-nav__toggle)"
        )
        .forEach((link) => {

          link.addEventListener(
            "click",
            () => {

              closeMobileMenu();

            }
          );

        });

    }


    /* =====================================================
       SEARCH
    ===================================================== */

    const openSearch = () => {

      if (!searchPanel) return;

      searchPanel.hidden = false;

      if (searchToggle) {

        searchToggle.setAttribute(
          "aria-expanded",
          "true"
        );

      }

      closeAllDropdowns();

      requestAnimationFrame(() => {

        if (searchInput) {

          searchInput.focus();

        }

      });

    };


    const closeSearch = () => {

      if (!searchPanel) return;

      searchPanel.hidden = true;

      if (searchToggle) {

        searchToggle.setAttribute(
          "aria-expanded",
          "false"
        );

      }

    };


    if (searchToggle) {

      searchToggle.addEventListener(
        "click",
        () => {

          const isOpen =
            searchToggle.getAttribute(
              "aria-expanded"
            ) === "true";

          if (isOpen) {

            closeSearch();

          } else {

            openSearch();

          }

        }
      );

    }


    /* =====================================================
       ESC KEY
    ===================================================== */

    document.addEventListener(
      "keydown",
      (event) => {

        if (event.key !== "Escape") {
          return;
        }

        closeAllDropdowns();

        closeMobileMenu();

        closeSearch();

      }
    );


    /* =====================================================
       CART COUNT
    ===================================================== */

    const updateCartCount = async () => {

      const countElement =
        header.querySelector(
          "[data-bh-cart-count]"
        );

      if (!countElement) return;


      try {

        const response =
          await fetch(
            `${window.Shopify.routes.root}cart.js`,
            {
              headers: {
                "Accept":
                  "application/json"
              }
            }
          );


        if (!response.ok) return;


        const cart =
          await response.json();


        countElement.textContent =
          cart.item_count;

      } catch (error) {

        console.warn(
          "Buffalo Header: Cart count update failed.",
          error
        );

      }

    };


    document.addEventListener(
      "cart:updated",
      updateCartCount
    );

    document.addEventListener(
      "cart:refresh",
      updateCartCount
    );


    /* =====================================================
       STICKY HEADER
    ===================================================== */

    const updateScrolledState = () => {

      if (
        !header.classList.contains(
          "bh-header--sticky"
        )
      ) {
        return;
      }


      if (window.scrollY > 10) {

        header.classList.add(
          "bh-scrolled"
        );

      } else {

        header.classList.remove(
          "bh-scrolled"
        );

      }

    };


    updateScrolledState();


    window.addEventListener(
      "scroll",
      updateScrolledState,
      {
        passive: true
      }
    );


    /* =====================================================
       RESIZE
    ===================================================== */

    let resizeTimer;

    window.addEventListener(
      "resize",
      () => {

        clearTimeout(resizeTimer);

        resizeTimer = setTimeout(() => {

          /*
           * Close desktop dropdowns when
           * switching between mobile/desktop.
           */

          closeAllDropdowns();


          if (window.innerWidth > 860) {

            closeMobileMenu();

          }

        }, 150);

      }
    );


    /* =====================================================
       INITIAL CART
    ===================================================== */

    updateCartCount();

  });

});